<div #cellWrapper [ngClass]="column.cellWrapperCss" [matTooltip]="stringDataMerge(element, column)">
    <ng-container #cellContainer></ng-container>
    <mat-progress-bar
        *ngIf="takingAction"
        mode="indeterminate"
        color="primary"></mat-progress-bar>
</div>